import Swiper from 'swiper';
// import remodal from 'remodal';

// スクロールアニメーション
const funcAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.9;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	check();
	if (document.readyState !== 'complete') {
		window.addEventListener('load', check, { once: true });
	}
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// スムーススクロール
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);
const duration = 500;

// ヘッダー: 下スクロール中は隠し、上スクロールで出す（メニューを開いている間とページ上部では常に表示）
const funcHeaderHide = () => {
	const header = document.querySelector('header');
	if (!header) return;
	const threshold = 10;
	let lastY = window.scrollY;
	let ticking = false;

	const update = () => {
		ticking = false;
		const y = window.scrollY;
		if (document.body.classList.contains('nav-open') || y <= header.offsetHeight) {
			header.classList.remove('is-hidden');
			lastY = y;
			return;
		}
		if (Math.abs(y - lastY) < threshold) return;
		header.classList.toggle('is-hidden', y > lastY);
		lastY = y;
	};

	window.addEventListener('scroll', () => {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(update);
	}, { passive: true });
};

window.addEventListener('DOMContentLoaded', () => {
	funcHeaderHide();

	const triggers = document.querySelectorAll('.anchor');
	let anchorFrame = 0;
	const cancelAnchor = () => { cancelAnimationFrame(anchorFrame); anchorFrame = 0; };
	window.addEventListener('wheel', cancelAnchor, { passive: true });
	window.addEventListener('touchstart', cancelAnchor, { passive: true });
	window.addEventListener('pointerdown', cancelAnchor, { passive: true });
	window.addEventListener('keydown', (event) => {
		if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) cancelAnchor();
	});

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			const href = trigger.getAttribute('href');
			if (!href || !href.startsWith('#')) return;

			const targetId = href.slice(1);
			if (!targetId) return;

			const targetElement = document.getElementById(targetId);
			if (!targetElement) return;

			e.preventDefault();
			e.stopPropagation();
			cancelAnchor();

			const headerOffset = window.innerWidth < 560 ? 100 : 140;
			const currentPosition = window.scrollY || 0;
			const targetPosition = currentPosition + targetElement.getBoundingClientRect().top - headerOffset;
			const distance = targetPosition - currentPosition;
			const startTime = performance.now();

			const loop = (nowTime) => {
				const time = nowTime - startTime;
				const normalizedTime = time / duration;

				if (normalizedTime < 1) {
					window.scrollTo(0, currentPosition + distance * easeInOut(normalizedTime));
					anchorFrame = requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, targetPosition);
					anchorFrame = 0;
				}
			};

			anchorFrame = requestAnimationFrame(loop);
		});
	});

	/////////////////////
	// HOME スライダー
	/////////////////////
	// CONTENT箇所
	const initProdSlider = () => {
		const mediaQuery = window.matchMedia('(max-width: 559px)');
		const slideProd = document.querySelectorAll('.prod__item .slide, .prod-styling .slide');
		const swiperInstances = [];

		// PC の watchOverflow 時に付く lock クラスは destroy で外れない。loop 時は update が no-op のため残り続け、SP でナビが消えたように見える
		const resetSlideNavigationUi = (slideEl) => {
			slideEl.querySelectorAll('.swiper-button-prev, .swiper-button-next').forEach((btn) => {
				btn.classList.remove('swiper-button-disabled', 'swiper-button-lock', 'swiper-button-hidden');
			});
		};

		// STYLING セクションのキャプション切替（画像切替でテキスト/クレジットをフェード）
		const syncStylingCaption = (stylingRoot, realIndex) => {
			const sets = stylingRoot.querySelectorAll('[data-styling-caption]');
			sets.forEach((set) => {
				set.classList.toggle('is-active', Number(set.dataset.stylingCaption) === realIndex);
			});
		};

		const initSwiper = (slideEl, isSp) => {
			const swiperEl = slideEl.querySelector('.swiper-container');
			if (!swiperEl) return null;

			const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
			const pagination = slideEl.querySelector('.swiper-pagination');
			const nextEl = slideEl.querySelector('.swiper-button-next');
			const prevEl = slideEl.querySelector('.swiper-button-prev');
			const stylingRoot = slideEl.closest('.prod-styling');

			if (stylingRoot) {
				// 推しアウターの Staff Code は SP も中央寄せで左右をのぞかせる（幅は CSS の 260）
				const inOshi = !!slideEl.closest('.oshi');
				const slidesPerView = isSp ? (inOshi ? 'auto' : 1) : 3;
				const spaceBetween = isSp ? (inOshi ? 10 : 0) : 20;
				return new Swiper(swiperEl, {
					loop: true,
					loopedSlides: inOshi ? slideCount : null,
					centeredSlides: !isSp || inOshi,
					slidesPerView,
					spaceBetween,
					speed: 800,
					autoplay: {
						delay: 4000,
						disableOnInteraction: false,
						waitForTransition: false,
					},
					navigation: { nextEl, prevEl },
					on: {
						init: function () {
							syncStylingCaption(stylingRoot, this.realIndex);
							const swiperInstance = this;
							if (!isSp) {
								const hoverTargets = [slideEl, stylingRoot.querySelector('.prod-styling__caption')].filter(Boolean);
								hoverTargets.forEach((el) => {
									el.addEventListener('mouseover', () => swiperInstance.autoplay.stop());
									el.addEventListener('mouseout', () => swiperInstance.autoplay.start());
								});
							}
						},
						slideChange: function () {
							syncStylingCaption(stylingRoot, this.realIndex);
						},
					},
				});
			}

			if (isSp) {
				if (slideCount <= 1) {
					return new Swiper(swiperEl, {
						watchOverflow: true,
						slidesPerView: 1,
						pagination: { el: pagination, type: 'bullets', clickable: true },
						navigation: { nextEl, prevEl },
					});
				}
				return new Swiper(swiperEl, {
					loop: true,
					slidesPerView: 1,
					speed: 1500,
					autoplay: {
						delay: 4000,
						disableOnInteraction: false,
						waitForTransition: false,
					},
					pagination: { el: pagination, type: 'bullets', clickable: true },
					navigation: { nextEl, prevEl },
					on: {
						init: function () {
							const swiperInstance = this;

							// SP: タッチでオートプレイ停止
							slideEl.addEventListener('touchstart', () => swiperInstance.autoplay.stop());
							slideEl.addEventListener('touchend', () => swiperInstance.autoplay.start());
						},
					},
				});
			}
			if (slideCount <= 3) {
				return new Swiper(swiperEl, {
					watchOverflow: true,
					slidesPerView: 3,
					pagination: { el: pagination, type: 'bullets', clickable: true },
					navigation: { nextEl, prevEl },
				});
			}
			return new Swiper(swiperEl, {
				loop: true,
				slidesPerView: 3,
				speed: 1000,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
					waitForTransition: false,
				},
				pagination: { el: pagination, type: 'bullets', clickable: true },
				navigation: { nextEl, prevEl },
				on: {
					init: function () {
						const swiperInstance = this;
						// PC: ホバーでオートプレイ停止
						slideEl.addEventListener('mouseover', () => swiperInstance.autoplay.stop());
						slideEl.addEventListener('mouseout', () => swiperInstance.autoplay.start());
					},
				},
			});
		};

		const checkBreakpoint = (mq) => {
			const isSp = mq.matches;
			swiperInstances.forEach((instance) => {
				if (instance && !instance.destroyed) instance.destroy(true, true);
			});
			swiperInstances.length = 0;
			slideProd.forEach(resetSlideNavigationUi);
			slideProd.forEach((slideEl) => {
				const instance = initSwiper(slideEl, isSp);
				if (instance) swiperInstances.push(instance);
			});
		};

		mediaQuery.addEventListener('change', checkBreakpoint);
		checkBreakpoint(mediaQuery);
	};
	initProdSlider();

	// HOME STYLINGスライダー
	const initStylingSlider = () => {
		const mediaQuery = window.matchMedia('(max-width: 559px)');
		let swiperInstance = null;

		const slideEl = document.querySelector('.styling__slider .slide');
		if (!slideEl) return;

		const swiperEl = slideEl.querySelector('.swiper-container');
		const wrapperEl = swiperEl.querySelector('.swiper-wrapper');
		const nextEl = slideEl.querySelector('.swiper-button-next');
		const prevEl = slideEl.querySelector('.swiper-button-prev');
		const paginationEl = slideEl.querySelector('.swiper-pagination');

		// 初期化前に全スライドを保存
		const allSlides = Array.from(wrapperEl.querySelectorAll('.swiper-slide')).map((el) => el.cloneNode(true));
		let currentCategory = '7';

		const setSlides = (category) => {
			wrapperEl.innerHTML = '';
			const filtered = category ? allSlides.filter((el) => el.dataset.category === category) : allSlides;
			filtered.forEach((el) => wrapperEl.appendChild(el.cloneNode(true)));
		};

		const init = (mq) => {
			if (swiperInstance && !swiperInstance.destroyed) swiperInstance.destroy(true, true);
			setSlides(currentCategory);
			const isSp = mq.matches;
			swiperInstance = new Swiper(swiperEl, {
				loop: true,
				slidesPerView: isSp ? 2 : 4,
				spaceBetween: isSp ? 10 : 20,
				speed: 800,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
					waitForTransition: false,
				},
				pagination: { el: paginationEl, type: 'bullets', clickable: true },
				navigation: { nextEl, prevEl },
				slidesPerGroup: isSp ? 2 : 4,
			});
		};

		// フィルターボタン
		const sliderEl = document.querySelector('.styling__slider');
		let filterTimer = 0;
		let filterRevision = 0;
		// const stylingBtn = document.getElementById('styling-btn');
		// const btnHrefs = { '1': '/lepsim/cp/the-standard1', '2': '/lepsim/cp/the-standard2', '3': '/lepsim/cp/the-standard3' };
		// const defaultHref = '/lepsim/cp/the-standard1';

		document.querySelectorAll('.styling__filter-btn').forEach((btn) => {
			btn.addEventListener('click', () => {
				const cat = btn.dataset.category;
				document.querySelectorAll('.styling__filter-btn').forEach((b) => b.classList.remove('is-active'));
				if (currentCategory === cat) {
					currentCategory = null;
					// if (stylingBtn) stylingBtn.href = defaultHref;
				} else {
					currentCategory = cat;
					btn.classList.add('is-active');
					// if (stylingBtn) stylingBtn.href = btnHrefs[cat] || defaultHref;
				}
				clearTimeout(filterTimer);
				const revision = ++filterRevision;
				sliderEl.style.animation = 'none';
				void sliderEl.offsetHeight;
				sliderEl.style.transition = 'opacity 0.3s ease';
				sliderEl.style.opacity = '0';
				filterTimer = setTimeout(() => {
					if (revision !== filterRevision) return;
					init(mediaQuery);
					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							if (revision !== filterRevision) return;
							sliderEl.style.opacity = '1';
						});
					});
				}, 300);
			});
		});

		// 初期ボタンをアクティブ化
		const defaultBtn = document.querySelector(`.styling__filter-btn[data-category="${currentCategory}"]`);
		if (defaultBtn) defaultBtn.classList.add('is-active');

		mediaQuery.addEventListener('change', () => {
			clearTimeout(filterTimer);
			filterRevision++;
			init(mediaQuery);
			sliderEl.style.opacity = '1';
		});
		init(mediaQuery);
	};
	initStylingSlider();

	// 他のスライダー
	// initOtherSlider();

	// スクロールアニメーション;
	funcAnim();
});
